/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module WelcomeModule
 */

import {
    Component,
    Input,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import { IUser } from 'generated-types';

import {
    BackupConfiguration,
    SystemConfig,
} from 'ajs/modules/system/factories';

// eslint-disable-next-line max-len
import { TELEMETRY_CEIP_URL } from 'ng/modules/system/components/system-settings-modal/telemetry-config/telemetry-config.constants';
import { TelemetryConfiguration } from 'object-types';
import * as globalL10n from 'global-l10n';
import * as l10n from './welcome-system-settings.l10n';
import './welcome-system-settings.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;
const { ...globalL10nKeys } = globalL10n;

/**
 * @description
 *
 * Welcome modal -> System settings panel component.
 *
 * @author Aravindh Nagarajan, Shubam Bindal
 */
@Component({
    selector: 'welcome-system-settings',
    templateUrl: './welcome-system-settings.component.html',
})
export class WelcomeSystemSettingsComponent {
    /**
     * Backup Configuration Item instance.
     */
    @Input()
    public backupConfig: BackupConfiguration;

    /**
     * SystemConfig Item instance.
     */
    @Input()
    public systemConfig: SystemConfig;

    /**
     * userAccount object containing editable user account fields.
     */
    @Input()
    public userAccount: IUser;

    /**
     * Get keys from source bundles for template usage
     */
    public readonly l10nKeys = l10nKeys;

    public readonly telemetryObjectType = TelemetryConfiguration;

    public readonly ceipUrl = TELEMETRY_CEIP_URL;

    public readonly globalL10nKeys = globalL10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}
